<template>
    <v-flex class="events" v-if="isSectionVisible()">
        <v-flex tag="h2">{{memberProfileConstants.ATTENDING_UPCOMING_EVENTS}}
            <i v-if="events.length > memberProfileConstants.THREE"
                class="fas fa-external-link-alt"
                data-qe-id="open-event-dialog_icon"
                @click="isEventDialog = true">
            </i>
        </v-flex>
        <status-overlay :action="loadGetEventsAction" content-height="200px">
        </status-overlay>
        <v-flex class="events__container inner-scrollbar">
            <v-layout row wrap v-for="(event, index) in events.slice(0,3)" :key="index">
                <v-flex xs2 class="date">
                    <v-flex tag="small">{{day(event)}}</v-flex>
                    <v-flex tag="strong">{{date(event)}}</v-flex>
                    <v-flex tag="small" v-if="isYearFormat(event)">
                        <v-flex tag="small">{{month(event)}}</v-flex>
                        <v-flex tag="small">{{year(event)}}</v-flex>
                    </v-flex>
                    <v-flex tag="small" v-else>{{month(event)}} {{year(event)}}</v-flex>
                    <v-flex tag="small"> {{time(event)}}</v-flex>
                </v-flex>
                <v-flex xs2 sm2>
                    <img :src="event.eventImageURL"  @error="eventImageFailHandler(event)"/>
                    </v-flex>
                    <v-flex xs7 sm8 class="desc">
                        <v-flex tag="strong"><a :data-qe-id="'UpcomingEvents_'+index" :href="event.eventUrl" target="_blank">{{truncateEventName(event.eventName, memberProfileConstants.TRUNCATE_LENGTH)}}</a></v-flex>
                        <v-flex tag="small">{{event.locationName}}</v-flex>
                    </v-flex>
            </v-layout>
        </v-flex>
        <v-dialog scrollable v-model="isEventDialog" content-class="medium">
            <v-card class="myprofile-popup attending-events">
                <v-card-title primary-title>
                    {{memberProfileConstants.ATTENDING_UPCOMING_EVENTS}}
                    <i class="fas fa-times"  data-qe-id="close-event-dialog_icon" @click="isEventDialog = false"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar">
                    <v-flex class="events">
                        <v-layout row wrap v-for="(event, index) in events" :key="index">
                            <v-flex xs1 class="date">
                                <v-flex tag="small">{{day(event)}}</v-flex>
                                <v-flex tag="strong">{{date(event)}}</v-flex>
                                <v-flex tag="small" v-if=isYearFormat(event)>
                                    <v-flex tag="small">{{month(event)}}</v-flex>
                                    <v-flex tag="small">{{year(event)}}</v-flex>
                                </v-flex>
                                <v-flex tag="small" v-else>{{month(event)}} {{year(event)}}</v-flex>
                                <v-flex tag="small"> {{time(event)}}</v-flex>
                            </v-flex>
                            <v-flex xs2>
                                <img :src="event.eventImageURL" :id="'eventImage_UnitTest_'+index"  @error="eventImageFailHandler(event)"/>
                            </v-flex>
                            <v-flex xs9 class="desc">
                                <v-flex tag="strong"><a :data-qe-id="'UpcomingEvents_'+index" :href="event.eventUrl" target="_blank">{{truncateEventName(event.eventName,  memberProfileConstants.TRUNCATE_LENGTH_POPOUT)}}</a></v-flex>
                                <v-flex tag="small">{{event.locationName}}</v-flex>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                    <v-btn flat class="primary_btn"  data-qe-id="close-dialog_btn" @click="isEventDialog = false">
                        {{appCommonConstants.CLOSE}}
                    </v-btn>
                </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { memberProfileConstants } from "./memberProfile.constants.js";
import { appCommonConstants } from "../appCommon.constants.js";
import StatusOverlay from '../StatusOverlay/StatusOverlay';

export default {
    name: "Events",
    data: () => ({
        memberProfileConstants,
        appCommonConstants,
        isEventDialog: false,
    }),
    components: {
        StatusOverlay,
    },
    props: {
        memberId: {
            type: String,
            required: true,
        },
    },
    created() {
        this.getEvents(this.memberId);
    },
    methods: {
        ...mapActions({
            getEvents: `memberProfile/${storeAction.getEvents}`,
        }),
        truncateEventName(eventName, characterCount) {
                if (eventName) {
                    return eventName.length > characterCount 
                            ? `${eventName.substring(0, characterCount)}` 
                            : eventName;
                }
        },
        isSectionVisible() {
            return this.events.length;
        },
        eventImageFailHandler(event) {
            event.eventImageURL = event.defaultEventImageURL;
        },
        time(event) {
            return event.startingTime === event.endingTime 
                    ? event.startingTime
                    : `${event.startingTime} - ${event.endingTime}`;
        },
        day(event) {
            return (event.startingDay === event.endingDay && event.startingMonth === event.endingMonth)
                    ? event.startingDay 
                    : `${event.startingDay} - ${event.endingDay}`;
        },
        date(event) {
            return (event.startingDayInMonth === event.endingDayInMonth && event.startingMonth === event.endingMonth && event.startingYear === event.endingYear)
                    ? event.startingDayInMonth 
                    : `${event.startingDayInMonth} - ${event.endingDayInMonth}`;
        },
        month(event) {
            return (event.startingMonth === event.endingMonth && event.startingYear === event.endingYear)
                    ? `${event.startingMonth}.`
                    : `${event.startingMonth} - ${event.endingMonth}.`;
        },
        year(event) {
            return event.startingYear === event.endingYear 
                    ? event.startingYear 
                    : `${event.startingYear} - ${event.endingYear}`;
        },
        isYearFormat(event) {
            return event.startingYear !== event.endingYear && event.startingMonth === event.endingMonth;
        },
        /* TODO: Will Uncomment when events are supposed to be Included
        eventCount() {
            return this.events.length > this.memberProfileConstants.THREE
                    ? `(${this.events.length})`
                    : '';
        }, */
    },
    computed: {
        ...mapGetters({
            events: `memberProfile/${storeGetters.events}`,
        }),
        ...mapState("actionState", ["actions"]),
        loadGetEventsAction() {
            return this.actions[storeAction.getEvents];
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";

.events {
    position: relative;
    border-bottom: 1px solid $ypo-open-blue-gray;
    margin-bottom: 20px;
    padding: 0 20px;

    &__container {
        max-height: 394px;
        overflow-y: auto;
        margin-right: 10px;
        overflow-x: hidden;

        }

    h2 {
        color: $ypo_blue;
        font-family: "Raleway", sans-serif;
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 20px;
        line-height: 26px;

        span {
            color: $ypo-cta;

            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            cursor: pointer;
        }

        i {
            color: $ypo-dark-background-gray;
            font-size: 14px;
            position: relative;
            left: 5px;
            margin-right: 40px;
            cursor: pointer;
        }

        em {
            color: $ypo-cta;
            font-family: "Noto Sans";
            font-size: 14px;
            line-height: 24px;
            font-style: normal;
            margin-left: 10px;
            cursor: pointer;
        }
    }

    .layout {
        margin: 15px 0;
        min-height: 85px;
    }

    .date {
        color: $ypo-dark-background-gray;
        font-weight: 500;
        line-height: 12px;

        small {
            font-size: 10px;
            display: block;
            line-height: normal;
            font-weight: 600;
        }

        strong {
            margin: 3px 0;
            display: block;
            color: $ypo_blue;
            font-family: "Raleway", sans-serif;
            font-size: 20px;
            font-weight: 500;
            line-height: 22px;
        }
    }

    img {
        max-width: 100%;
        display: block;
        margin: auto;
        border-radius: 4px;
    }

    .desc {
        padding-left: 15px;

        strong {
            color: $ypo-cta;
            font-size: 14px;
            font-weight: bold;
            line-height: 19px;
            display: block;

            a {
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        small {
            color: $ypo-dark-gray;
            font-family: "Noto Sans";
            font-size: 12px;
            line-height: 18px;
            display: block;
        }
    }

    @media (max-width: 1199px){
        padding: 0 0 20px 0;
    }    

    .overlay {
        top: 35px;
    }
}

.v-dialog {
    .events {
        border-bottom: none;
        .desc {
            word-break: break-word;
            padding-left: 0;
        }
    }
}
.attending-events {
    .events {
            img {
            max-height: 85px;
            display: block;
            margin: auto;
            border-radius: 4px;
        }
    }
}
</style>
